import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { runInThisContext } from 'vm';

@Component({
  selector: 'app-programmations',
  templateUrl: './programmations.component.html',
  styleUrls: ['./programmations.component.css']
})
export class ProgrammationsComponent implements OnInit {
  @Input() programme;
  @Input() depuisDT;
  @Input() module = 'ecobenne';
  @Input() isHistoLoc;


  listProgram = [
    { id: 1, libelleObjetEntite: 'Jour du mois' },
    { id: 0, libelleObjetEntite: 'Jour de la semaine' },
    { id: 2, libelleObjetEntite: 'Jour et semaine du mois' },
    { id: 3, libelleObjetEntite: 'Dernière semaine du mois' },
  ];

  listSemaine = [
    { id: 2, libelleObjetEntite: 'LUN' },
    { id: 3, libelleObjetEntite: 'MAR' },
    { id: 4, libelleObjetEntite: 'MER' },
    { id: 5, libelleObjetEntite: 'JEU' },
    { id: 6, libelleObjetEntite: 'VEN' },
    { id: 7, libelleObjetEntite: 'SAM' },
    { id: 1, libelleObjetEntite: 'DIM' },
  ];

  listJour = [];
  selected = [];
  nbSemainesProgram = '1';
  mouvBenneProgramme: any = {};
  programmeEdit: any = {};
  deepEdit: any = {};
  editPgm: Boolean = false;

  tempMvtProgramme: any = {};
  loadingIndicator: Boolean = false;
  qteSupp: Boolean = false;
  public isJourFerie: Boolean = false;
  public isSuspension: Boolean = false;
  error = '';
  tmp: any = {};
  societe: any = {};
  listMouvementsParPeriode = [];
  valuerdeep: any = {};

  @ViewChild('msg') msg;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  @Output() saveFerier = new EventEmitter<any>();
  @Output() saveSusp = new EventEmitter<any>();
  @Output() savePeriode = new EventEmitter<any>();

  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.societe = this.common.local.getObject('paramSociete') || {};
    console.log('hisot', this.isHistoLoc)
    console.log(this.societe)
    // this.changeProgram();
    for (let i = 0; i < 31; i++) {
      this.listJour.push({ id: i + 1, libelleObjetEntite: i + 1 });
    }
    const listSupp = [{ id: -1, libelleObjetEntite: 1 },
    { id: -1, libelleObjetEntite: 2 },
    { id: -1, libelleObjetEntite: 3 },
    { id: -1, libelleObjetEntite: 4 }];
    this.listJour = [...this.listJour, ...listSupp];
    this.mouvBenneProgramme = this.deepCopy(this.programme ? this.programme : this.mouvBenneProgramme);
    this.tmp = this.programme ? Object.assign({}, this.programme) : this.mouvBenneProgramme;

    this.mouvBenneProgramme = this.mvtProgramme(this.mouvBenneProgramme);
    if (this.societe['programBenneMultiperiodes']) {
      const objParDefaut = Object.assign({}, this.mouvBenneProgramme);
      objParDefaut.libellePeriode = 'Par défaut';
      this.listMouvementsParPeriode.push(objParDefaut);
      objParDefaut.listMouvementsParPeriode = objParDefaut.listMouvementsParPeriode || [];
      objParDefaut.listMouvementsParPeriode.forEach((element, idx) => {
        if (element.id == 0) {
          element.id = -1 * (idx + 1)
        }
        const benneProgramme = this.mvtProgrammePeriode(Object.assign({}, element));
        benneProgramme.dateDebut = moment(benneProgramme.dateDebut || '01/01/2000 00:00:00', 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        benneProgramme.dateFin = moment(benneProgramme.dateFin || '31/12/9999 00:00:00', 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        benneProgramme.libellePeriode = `${benneProgramme.dateDebut}-${benneProgramme.dateFin}`;
        this.listMouvementsParPeriode.push(benneProgramme);
      });
    }

    this.valuerdeep = this.deepCopy(JSON.parse(JSON.stringify(this.mouvBenneProgramme)));

  }

  changeProgram() {
    this.mouvBenneProgramme['typeProgram'] = this.listProgram[1];
    this.mouvBenneProgramme['frequence'] = 1;
    this.mouvBenneProgramme['typeOperation'] = 0;
    this.mouvBenneProgramme['listTtSemaine'] = [];
    this.mouvBenneProgramme['listSemainePaire'] = [];
    this.mouvBenneProgramme['listSemaineImpaire'] = [];
    this.mouvBenneProgramme['listJoursMois'] = [];
    this.mouvBenneProgramme['listJoursMois1'] = [];
    this.mouvBenneProgramme['listJoursMois2'] = [];
    this.mouvBenneProgramme['listJoursMois3'] = [];
    this.mouvBenneProgramme['listJoursMois4'] = [];
    this.mouvBenneProgramme['listJoursMois5'] = [];
    this.mouvBenneProgramme['listJoursDerSemaineMois'] = [];
  }

  mvtProgramme(mouvBenneProgramme) {
    if (mouvBenneProgramme['id']) {
      if (mouvBenneProgramme['typeOperation']) {
        this.listProgram.forEach(elt => {
          if (elt.id === mouvBenneProgramme['typeOperation']) {
            mouvBenneProgramme['typeProgram'] = elt;
          }
        });
      } else {
        mouvBenneProgramme['typeProgram'] = this.listProgram[1];
        mouvBenneProgramme['typeOperation'] = 0;
      }
      if (mouvBenneProgramme['dateFin']) {
        if (mouvBenneProgramme['dateFin'] !== '31/12/9999') {
          mouvBenneProgramme['editDate'] = true;
        }
        const date = moment(mouvBenneProgramme['dateFin'],
          'DD/MM/YYYY HH:mm:ss').isValid() ? moment(mouvBenneProgramme['dateFin'],
            'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : moment(mouvBenneProgramme['dateFin'],
              'DD/MM/YYYY').format('DD/MM/YYYY')
        mouvBenneProgramme['datePgm'] = this.common.parseDate(date);
        console.log(mouvBenneProgramme['datePgm']);

        if (date !== '01/01/1970') {
          mouvBenneProgramme['datePgm'] = this.common.parseDate(date);
        } else {
          mouvBenneProgramme['datePgm'] = this.common.parseDate('31/12/9999');
        }
      } else {
        mouvBenneProgramme['dateFin'] = '31/12/9999';
      }
      mouvBenneProgramme['nbSemainesProgram'] = '' + (mouvBenneProgramme['nbSemainesProgram'] || 1);
      mouvBenneProgramme['frequence'] = mouvBenneProgramme['frequence'] || 0;
      // mouvBenneProgramme['listTtSemaine'] = [];
      // mouvBenneProgramme['listSemainePaire'] = [];
      // mouvBenneProgramme['listSemaineImpaire'] = [];
      // mouvBenneProgramme['listJoursMois'] = [];
      // mouvBenneProgramme['listJoursMois1'] = [];
      // mouvBenneProgramme['listJoursMois2'] = [];
      // mouvBenneProgramme['listJoursMois3'] = [];
      // mouvBenneProgramme['listJoursMois4'] = [];
      // mouvBenneProgramme['listJoursMois5'] = [];
      // mouvBenneProgramme['listJoursDerSemaineMois'] = [];
      mouvBenneProgramme['listePeriodesPause'] = mouvBenneProgramme['listePeriodesPause'] || [];
      mouvBenneProgramme['typeOperation'] = mouvBenneProgramme['typeOperation'] || 0;
      switch (mouvBenneProgramme['typeOperation']) {
        case 0:
          if (mouvBenneProgramme['nbSemainesProgram'] === '1') {
            mouvBenneProgramme['listTtSemaine'] = mouvBenneProgramme['listTtSemaine'] ||
              mouvBenneProgramme['listJours'] || [];
          } else {
            mouvBenneProgramme['listSemainePaire'] = mouvBenneProgramme['listSemainePaire'] ||
              mouvBenneProgramme['listJours'] || [];
            mouvBenneProgramme['listSemaineImpaire'] = mouvBenneProgramme['listSemaineImpaire'] ||
              mouvBenneProgramme['listJoursSemaine2'] || [];
          }
          break;
        case 1:
          mouvBenneProgramme['listJoursMois'] = mouvBenneProgramme['listJoursMois'] ||
            mouvBenneProgramme['listJours'] || [];
          break;
        case 2:
          mouvBenneProgramme['listJoursMois1'] = mouvBenneProgramme['listJoursMois1'] ||
            mouvBenneProgramme['listJours'] || [];
          mouvBenneProgramme['listJoursMois2'] = mouvBenneProgramme['listJoursMois2'] ||
            mouvBenneProgramme['listJoursSemaine2'] || [];
          mouvBenneProgramme['listJoursMois3'] = mouvBenneProgramme['listJoursMois3'] ||
            mouvBenneProgramme['listJoursSemaine3'] || [];
          mouvBenneProgramme['listJoursMois4'] = mouvBenneProgramme['listJoursMois4'] ||
            mouvBenneProgramme['listJoursSemaine4'] || [];
          mouvBenneProgramme['listJoursMois5'] = mouvBenneProgramme['listJoursMois5'] ||
            mouvBenneProgramme['listJoursSemaine5'] || [];
          break;
        case 3:
          mouvBenneProgramme['listJoursDerSemaineMois'] = mouvBenneProgramme['listJoursDerSemaineMois'] ||
            mouvBenneProgramme['listJours'] || [];
          break;
      }
    } else {
      mouvBenneProgramme['typeOperation'] = mouvBenneProgramme['typeProgram'].id || 0;
      mouvBenneProgramme['nbSemainesProgram'] = '1';
      if (mouvBenneProgramme['dateFin']) {
        if (mouvBenneProgramme['dateFin'] !== '31/12/9999') {
          mouvBenneProgramme['editDate'] = true;
        }
        const date = moment(mouvBenneProgramme['dateFin'],
          'DD/MM/YYYY HH:mm:ss').isValid() ? moment(mouvBenneProgramme['dateFin'],
            'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : moment(mouvBenneProgramme['dateFin'],
              'DD/MM/YYYY').format('DD/MM/YYYY')
        mouvBenneProgramme['datePgm'] = this.common.parseDate(date);
        console.log(mouvBenneProgramme['datePgm'])
      } else {
        mouvBenneProgramme['dateFin'] = '31/12/9999';
      }
      console.log(mouvBenneProgramme)
    }

    return mouvBenneProgramme;
  }

  mvtProgrammePeriode(pgmPeriode) {
    if (pgmPeriode['id'] || this.depuisDT) {
      if (pgmPeriode['typeOperation']) {
        this.listProgram.forEach(elt => {
          if (elt.id === pgmPeriode['typeOperation']) {
            pgmPeriode['typeProgram'] = elt;
          }
        });
      } else {
        pgmPeriode['typeProgram'] = this.listProgram[1];
        pgmPeriode['typeOperation'] = 0;
      }
      if (pgmPeriode['dateFin']) {
        pgmPeriode['editDate'] = true;
        if (pgmPeriode['dateFin'] !== '01/01/1970 00:00:00') {
          pgmPeriode['datePgm'] = this.common.parseDate(moment((pgmPeriode['dateFin']),
            'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        } else {
          pgmPeriode['datePgm'] = this.common.parseDate('31/12/9999');
        }

      }
      pgmPeriode['nbSemainesProgram'] = '' + (pgmPeriode['nbSemainesProgram'] || 1);
      pgmPeriode['frequence'] = pgmPeriode['frequence'] || 0;
      pgmPeriode['listTtSemaine'] = [];
      pgmPeriode['listSemainePaire'] = [];
      pgmPeriode['listSemaineImpaire'] = [];
      pgmPeriode['listJoursMois'] = [];
      pgmPeriode['listJoursMois1'] = [];
      pgmPeriode['listJoursMois2'] = [];
      pgmPeriode['listJoursMois3'] = [];
      pgmPeriode['listJoursMois4'] = [];
      pgmPeriode['listJoursMois5'] = [];
      pgmPeriode['listJoursDerSemaineMois'] = [];
      pgmPeriode['listePeriodesPause'] = pgmPeriode['listePeriodesPause'] || [];
      pgmPeriode['typeOperation'] = pgmPeriode['typeOperation'] || 0;
      switch (pgmPeriode['typeOperation']) {
        case 0:
          if (pgmPeriode['nbSemainesProgram'] === '1') {
            pgmPeriode['listTtSemaine'] = pgmPeriode['listJours'] || [];
          } else {
            pgmPeriode['listSemainePaire'] = pgmPeriode['listJoursSemaine2'] || [];
            pgmPeriode['listSemaineImpaire'] = pgmPeriode['listJours'] || [];
          }
          break;
        case 1:
          pgmPeriode['listJoursMois'] = pgmPeriode['listJours'] || [];
          break;
        case 2:
          pgmPeriode['listJoursMois1'] = pgmPeriode['listJours'] || [];
          pgmPeriode['listJoursMois2'] = pgmPeriode['listJoursSemaine2'] || [];
          pgmPeriode['listJoursMois3'] = pgmPeriode['listJoursSemaine3'] || [];
          pgmPeriode['listJoursMois4'] = pgmPeriode['listJoursSemaine4'] || [];
          pgmPeriode['listJoursMois5'] = pgmPeriode['listJoursSemaine5'] || [];
          break;
        case 3:
          pgmPeriode['listJoursDerSemaineMois'] = pgmPeriode['listJours'] || [];
          break;
      }
    } else {
      pgmPeriode['typeProgram'] = this.listProgram[1];
      pgmPeriode['typeOperation'] = 0;
      pgmPeriode['nbSemainesProgram'] = '1'
    }
    return pgmPeriode;
  }

  createObjtMvtBennePgm(mouvBenneProgramme) {
    if (mouvBenneProgramme['tableConfigJoursFeries']) {
      mouvBenneProgramme['tableConfigJoursFeries'].forEach(elt => {
        if (elt.configJourFerie) {
          elt.configJourFerie.rattrapageLendemain = elt.configJourFerie.rattrapageLendemain || false;
        }
      });
    }
    const mouv = {
      id: mouvBenneProgramme['id'] || 0,
      typeOperation: mouvBenneProgramme['typeOperation'],
      frequence: mouvBenneProgramme['frequence'],
      tableConfigJoursFeries: mouvBenneProgramme['tableConfigJoursFeries'],
      listePeriodesPause: mouvBenneProgramme['listePeriodesPause'],
      nomclass: 'MouvementBenneProgramme',
    };
    switch (mouvBenneProgramme['typeOperation']) {
      case 0:
        mouv['nbSemainesProgram'] = mouvBenneProgramme['nbSemainesProgram'];
        if (mouvBenneProgramme['nbSemainesProgram'] === '1') {
          mouv['listJours'] = mouvBenneProgramme['listTtSemaine'] || [];
        } else {
          mouv['listJours'] = mouvBenneProgramme['listSemaineImpaire'] || [];
          mouv['listJoursSemaine2'] = mouvBenneProgramme['listSemainePaire'] || [];
        }
        break;
      case 1:
        mouv['listJours'] = mouvBenneProgramme['listJoursMois'] || [];
        break;
      case 2:
        mouv['listJours'] = mouvBenneProgramme['listJoursMois1'] || [];
        mouv['listJoursSemaine2'] = mouvBenneProgramme['listJoursMois2'] || [];
        mouv['listJoursSemaine3'] = mouvBenneProgramme['listJoursMois3'] || [];
        mouv['listJoursSemaine4'] = mouvBenneProgramme['listJoursMois4'] || [];
        mouv['listJoursSemaine5'] = mouvBenneProgramme['listJoursMois5'] || [];
        break;
      case 3:
        mouv['listJours'] = mouvBenneProgramme['listJoursDerSemaineMois'] || [];
        break;
    }

    return mouv;
  }

  changeFrequence() {
    if (this.mouvBenneProgramme['nbSemainesProgram'] === '2') {
      this.mouvBenneProgramme['frequence'] = 1;
    }
  }

  showJourFerie() {
    this.isJourFerie = !this.isJourFerie;
  }

  saveJourFerier(event) {
    if (!this.editPgm) {
      this.mouvBenneProgramme['tableConfigJoursFeries'] = event;
    } else {
      this.programmeEdit['tableConfigJoursFeries'] = event;
    }
  }

  showSuspension() {
    this.isSuspension = !this.isSuspension;
  }

  saveSuspension(event) {
    if (!this.editPgm) {
      this.mouvBenneProgramme['listePeriodesPause'] = event;
    } else {
      this.programmeEdit['listePeriodesPause'] = event;
    }
    // this.mouvBenneProgramme['listePeriodesPause'] = event;
  }

  selectedDay(list, elem) {
    list = list || [];
    if (elem > 0) {
      const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
      return listfilter.length ? true : false;
    } else {
      return false;
    }
  }

  selectedSemaine(list, elem) {
    list = list || [];
    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    return listfilter.length ? true : false;
  }

  checkDayWeek(list, elem) {
    list = list || [];

    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    if (listfilter.length) {
      let index;
      list.forEach((elt, idx) => {
        if (parseInt(elt, 10) === parseInt(elem, 10)) {
          index = idx;
        }
      });
      // const index = list.indexOf('' + 5);
      list.splice(index, 1);
      list = [...list];
    } else {
      list.push('' + elem);
      list = [...list];
    }
  }

  changeDatePgm(event) {
    if (moment(event).isValid()) {
      this.mouvBenneProgramme['dateFin'] = moment(event).format('DD/MM/YYYY');
    } else {
      this.mouvBenneProgramme['dateFin'] = !this.mouvBenneProgramme['datePgm'] || this.mouvBenneProgramme['datePgm'] === '' ?
        '31/12/9999' : moment().format('DD/MM/YYYY');
    }
  }

  changeDate(event, key, obj, datePgm) {
    if (moment(event).isValid()) {
      obj[key] = moment(event).format('DD/MM/YYYY');
    } else {
      obj[key] = !obj[datePgm] || obj[datePgm] === '' ?
        (obj === 'dateFin' ? '31/12/9999' : '01/01/2000') : moment().format('DD/MM/YYYY');
    }
  }

  fermer() {
    this.programme = {};
    this.programme = this.valuerdeep;
    this.mouvBenneProgramme = this.valuerdeep;
    console.log('fermer programe', this.programme, this.valuerdeep, this.mouvBenneProgramme)

    this.showFiche();
  }

  deepCopy(obj) {
    let copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || 'object' !== typeof obj) { return obj; }

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (let i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.deepCopy(obj[i]);
      }
      return Object.assign([], copy);
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (const attr in obj) {
        if (obj.hasOwnProperty(attr)) { copy[attr] = this.deepCopy(obj[attr]); }
      }
      return Object.assign({}, copy);
    }

    throw new Error('Unable to copy obj! Its type isn\'t supported.');
  }

  showFiche() {
    this.hidefunction.emit();
  }

  modifProgram(mouvBenneProgramme) {
    let isModif = false;
    const listTtSemaine = mouvBenneProgramme['listTtSemaine'] && mouvBenneProgramme['listTtSemaine'].length ? true : false,
      listSemainePaire = mouvBenneProgramme['listSemainePaire'] && mouvBenneProgramme['listSemainePaire'].length ? true : false,
      listSemaineImpaire = mouvBenneProgramme['listSemaineImpaire'] && mouvBenneProgramme['listSemaineImpaire'].length ? true : false,
      listJoursMois = mouvBenneProgramme['listJoursMois'] && mouvBenneProgramme['listJoursMois'].length ? true : false,
      listJoursMois1 = mouvBenneProgramme['listJoursMois1'] && mouvBenneProgramme['listJoursMois1'].length ? true : false,
      listJoursMois2 = mouvBenneProgramme['listJoursMois2'] && mouvBenneProgramme['listJoursMois2'].length ? true : false,
      listJoursMois3 = mouvBenneProgramme['listJoursMois3'] && mouvBenneProgramme['listJoursMois3'].length ? true : false,
      listJoursMois4 = mouvBenneProgramme['listJoursMois4'] && mouvBenneProgramme['listJoursMois4'].length ? true : false,
      listJoursMois5 = mouvBenneProgramme['listJoursMois5'] && mouvBenneProgramme['listJoursMois5'].length ? true : false,
      listJoursDerSemaineMois = mouvBenneProgramme['listJoursDerSemaineMois'] && mouvBenneProgramme['listJoursDerSemaineMois'].length ? true : false;
    if (listTtSemaine || listSemainePaire || listSemaineImpaire || listJoursMois || listJoursMois1 || listJoursMois2
      || listJoursMois3 || listJoursMois4 || listJoursMois5 || listJoursDerSemaineMois) {
      isModif = true;
    }
    return isModif;
  }

  save() {
    let pgm = Object.assign({}, this.mouvBenneProgramme);
    if (this.societe['programBenneMultiperiodes']) {
      const programeParDefaut = this.listMouvementsParPeriode.filter(elt => elt.libellePeriode === 'Par défaut');
      if (programeParDefaut && programeParDefaut[0]) {
        pgm = Object.assign({}, programeParDefaut[0]);
      }
      const programePeriode = this.listMouvementsParPeriode.filter(elt => elt.libellePeriode !== 'Par défaut');
      pgm.listMouvementsParPeriode = [];
      programePeriode.forEach(pgmperiode => {
        const objFinal = this.createObjtMvtBennePgm(pgmperiode);
        objFinal['dateDebut'] = pgmperiode.dateDebut;
        objFinal['dateFin'] = pgmperiode.dateFin;
        pgm.listMouvementsParPeriode.push(objFinal);
      });
    } else {
      if (!this.modifProgram(this.mouvBenneProgramme)) {
        this.error = 'Il faut sélectionner au moins un jour.';
        this.common.openModal(this.modalService, this.msg);
        return;
      }
      if (this.module === 'ecoloc' && !this.mouvBenneProgramme['datePgm'] && this.mouvBenneProgramme['editDate']) {
        this.error = 'La date de fin est invalide';
        this.common.openModal(this.modalService, this.msg);
        return;
      }
    }
    console.log(pgm)
    if (pgm['datePgm'] && typeof pgm['datePgm'] === 'string' &&
      pgm['datePgm'].match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
      pgm['dateFin'] = pgm['datePgm'];
    } else {
      if (pgm['datePgm'] && moment(pgm['datePgm']).isValid()) {
        pgm['dateFin'] = moment(pgm['datePgm']).format('DD/MM/YYYY');
      } else {
        if (!pgm['datePgm'] || pgm['datePgm'] === '') {
          pgm['dateFin'] = '31/12/9999';
        }
      }
    }
    this.programme = pgm;
    this.saveFerier.emit(this.programme['tableConfigJoursFeries']);
    this.saveSusp.emit(this.programme['listePeriodesPause']);
    this.savePeriode.emit(this.programme);
    this.showFiche();
  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  setFocuscalendar(event) {
  }

  editLignePgm(row) {
    this.editPgm = true;
    // this.deepEdit = this.deepCopy(row);
    this.programmeEdit = this.deepCopy(row);
    this.selected = [row];
    if (this.programmeEdit.libellePeriode !== 'Par défaut') {
      this.programmeEdit['dateDebutPgmModel'] = this.common.parseDate(this.programmeEdit['dateDebut']);
      this.programmeEdit['dateFinPgmModel'] = this.common.parseDate(this.programmeEdit['dateFin']);
    }

    console.log(this.programmeEdit)
  }

  addLigne() {
    const row = {
      id: -1 * (this.listMouvementsParPeriode.length + 1),
      dateDebut: moment().format('DD/MM/YYYY'),
      dateFin: moment().format('DD/MM/YYYY'),
      dateDebutPgmModel: new Date(),
      dateFinPgmModel: new Date(),
      editDate: true,
    };

    this.listMouvementsParPeriode.push(row);
    this.listMouvementsParPeriode = [...this.listMouvementsParPeriode];
    this.editPgm = true;
    this.deepEdit = this.deepCopy(row);
    this.programmeEdit = row;
    this.selected = [row];
    this.programmeEdit['typeProgram'] = this.listProgram[1];
    this.programmeEdit['frequence'] = 1;
    this.programmeEdit['libellePeriode'] = '';
    this.programmeEdit['typeOperation'] = 0;
    this.programmeEdit['listTtSemaine'] = [];
    this.programmeEdit['listSemainePaire'] = [];
    this.programmeEdit['listSemaineImpaire'] = [];
    this.programmeEdit['listJoursMois'] = [];
    this.programmeEdit['listJoursMois1'] = [];
    this.programmeEdit['listJoursMois2'] = [];
    this.programmeEdit['listJoursMois3'] = [];
    this.programmeEdit['listJoursMois4'] = [];
    this.programmeEdit['listJoursMois5'] = [];
    this.programmeEdit['listJoursDerSemaineMois'] = [];
  }

  fermerEdit() {
    this.programmeEdit = this.deepEdit;
  }

  closeEdit() {
    if (this.programmeEdit.libellePeriode !== 'Par défaut') {
      if ((!this.programmeEdit['dateDebutPgmModel'] || !this.programmeEdit['dateFinPgmModel'])) {
        this.error = 'Les date de debut ou fin sont invalides';
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
      if ((this.programmeEdit['dateDebut'] && this.programmeEdit['dateFin'] &&
        moment(this.programmeEdit['dateDebut'], 'DD/MM/YYYY').isSameOrAfter(moment(this.programmeEdit['dateFin'], 'DD/MM/YYYY')))) {
        this.error = 'La date de debut doit être avant la date de fin';
        this.common.openModal(this.modalService, this.msg);
        return false;
      }

      let date = false;

      const row = this.programmeEdit;
      let temp = [];
      this.listMouvementsParPeriode.forEach(elem => {
        if (((row.libellePeriode !== 'Par défaut') && (row.id === elem.id)) ||
          ((row.libellePeriode === elem.libellePeriode) && (row.libellePeriode === 'Par défaut'))) {
          elem = row
        }
        temp.push(elem);
      });


      this.listMouvementsParPeriode = [...temp];
      const listeReste = this.listMouvementsParPeriode.filter(r => r.id !== row.id);
      listeReste.forEach(elt => {
        const debut = moment(elt.dateDebut, 'DD/MM/YYYY');
        const fin = moment(elt.dateFin, 'DD/MM/YYYY');
        if (moment(row.dateDebut, 'DD/MM/YYYY').isBetween(debut, fin) ||
          moment(row.dateDebut, 'DD/MM/YYYY').isSame(debut) || moment(row.dateDebut, 'DD/MM/YYYY').isSame(fin) ||
          moment(row.dateFin, 'DD/MM/YYYY').isSame(debut) || moment(row.dateFin, 'DD/MM/YYYY').isSame(fin) ||
          moment(row.dateFin, 'DD/MM/YYYY').isBetween(debut, fin)) {
          date = true;
        }
      });

      if (date) {
        this.error = 'La periode spécifiée recouvre une autre periode de la liste.';
        this.common.openModal(this.modalService, this.msg);
        return false
      }

      this.programmeEdit.libellePeriode = row.dateDebut + '-' + row.dateFin;
    } else {
      const temp = [];
      const row = this.programmeEdit;
      this.listMouvementsParPeriode.forEach(elem => {
        if (elem.libellePeriode === 'Par défaut') {
          elem = row
        }
        temp.push(elem);
      });
      this.listMouvementsParPeriode = [...temp];
    }

    // this.programmeEdit.objFinal = this.createObjtMvtBennePgm(this.programmeEdit);

    if (!this.modifProgram(this.programmeEdit)) {
      this.error = 'Il faut sélectionner au moins un jour.';
      this.common.openModal(this.modalService, this.msg);
      return;
    }
    console.log(this.listMouvementsParPeriode);
    this.editPgm = false;

  }

  deleteLigne(row) {
    this.listMouvementsParPeriode = this.listMouvementsParPeriode.filter(elt => elt.id !== row.id);
    this.listMouvementsParPeriode = [...this.listMouvementsParPeriode];
  }

  setDefaultDateFin(param) {
    if ((param == 'programmeEdit') && this.programmeEdit.editDate && (this.programmeEdit['dateFin'] == '31/12/9999')) {
      if (this.module === "ecoloc") {
        this.programmeEdit.datePgm = "";
      } else {
        this.programmeEdit.datePgm = this.common.parseDate(moment().format('DD/MM/YYYY'));
      }
    }

    if ((param == 'mouvBenneProgramme') && this.mouvBenneProgramme.editDate && (this.mouvBenneProgramme['dateFin'] == '31/12/9999')) {
      if (this.module === 'ecoloc') {
        this.mouvBenneProgramme.datePgm = "";
      } else {
        this.mouvBenneProgramme.datePgm = this.common.parseDate(moment().format('DD/MM/YYYY'));
      }
    }
  }

  disableDay(elem) {
    // list = list || [];
    // const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    // return listfilter.length ? true : false;
    const siteUser = this.common.local.getObject('siteUser') || {};
    if (this.module === 'ecobenne' || this.module === 'ecoloc') {
      if ((!siteUser['travailSamediTheorique']) && parseInt(elem, 10) === 7) {
        return true
      }

      if ((!siteUser['travailDimanche'] && !siteUser['travailDimancheTheorique']) && parseInt(elem, 10) === 1) {
        return true
      }
    }


    return false
  }

}
